import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';

// The Payment icons have a standard size 40 x 24 and chroma
const Visa: FC<IconV2Props> = ({ icon, className }) => (
  <svg
    width="40"
    height="24"
    viewBox="0 0 40 24"
    xmlns="http://www.w3.org/2000/svg"
    className={cn(className, `svg-icon--${icon}`)}
  >
    <g fill="none" fillRule="evenodd">
      <path
        d="M0 0h40v24H0V0Zm1 1v22h38V1H1Z"
        fill="#D5D6D6"
        fillRule="nonzero"
      />
      <path
        d="M23.732 7.073c1.072 0 2.101.39 2.101.39L25.5 9.392c-1-.55-3.275-.681-3.275.333s3.26 1.232 3.26 3.564c0 2.246-2.405 3.072-3.999 3.072-1.594 0-2.637-.507-2.637-.507l.348-2.014c.956.768 3.854.985 3.854-.232s-3.231-1.246-3.231-3.564c0-2.463 2.753-2.97 3.912-2.97Zm-15.008.16c.954 0 1.094.716 1.108.8v.008l.786 4.034.264 1.33 2.227-6.172h2.514l-3.716 8.973H9.473L7.443 8.41c-1.257-.756-2.34-1.003-2.436-1.024L5 7.385l.043-.152h3.681Zm10.146 0-1.46 8.973h-2.336l1.46-8.973h2.336Zm12.887 0 1.87 8.973h-2.145l-.274-1.333h-2.97l-.486 1.333h-2.435L28.8 7.902s.183-.583.913-.66l.165-.009h1.878Zm-1.618 2.441-1.227 3.358h1.918l-.69-3.358Z"
        fill="#0066B2"
      />
      <path
        d="M10.619 12.076 9.833 8.04s-.095-.808-1.109-.808h-3.68L5 7.385s1.77.367 3.467 1.74c1.622 1.314 2.152 2.95 2.152 2.95"
        fill="#F9A633"
      />
    </g>
  </svg>
);

export default Visa;
